import { OrderType } from '../../../types/OrderType'
import { AddToCartTicketType, CartData } from '../../../types/CartType';
import { GoogleDataLayerEcommerceActionField , GoogleDataLayerEcommerceProduct, GoogleDataLayerEcommerceEventPurchase, GoogleDataLayerEcommerceEventAddToCart } from '../../../types/GoogleDataLayerEventType'

export class GoogleDataLayer {

  private buildActionFieldProperty(order: OrderType){

    const orderTickets = order.order_tickets

    // Checking if the order is a hotel order
    let hotel_order = false;
    orderTickets.forEach((ticket) => {
      if(ticket.tags.includes('hotels')){
        hotel_order = true;
      }
    })

    const actionField: GoogleDataLayerEcommerceActionField = {
      id: order.id,
      revenue: order.total,
      paymentMethod: order.order_payments[0].method,
      bookingType: hotel_order ? 'hotel_order' : 'ticket_order',
      currency: order.currency,
      departureDate: order.departure_date
    }

    return actionField
  }

  private buildProductProperty(name: string, id: string, price: string, quantity: number, variant: string, destination: string){

    const product: GoogleDataLayerEcommerceProduct = {
      name: name,
      id: id,
      price: price,
      quantity: quantity,
      variant: variant,
      destination: destination
    }

    return product
  }

  public logAddToCart(cartData: CartData, ticketsAdded: Array<AddToCartTicketType>) {

    const cartDataTickets = cartData.tickets
    const listOfTickets: Array<GoogleDataLayerEcommerceProduct> = []

    cartDataTickets.forEach(cartTicket => {
      const ticketData = ticketsAdded.find((ticket) => ticket.ticketId === cartTicket.ticket_id)
      if(ticketData) {
        const product = this.buildProductProperty(cartTicket.title, cartTicket.ticket_id, cartTicket.price, ticketData.qty, `${cartTicket.title} ${cartTicket.data.type_ticket}`, cartTicket.destination_title);
        listOfTickets.push(product)
      }

    })

    const event: GoogleDataLayerEcommerceEventAddToCart = {
      event: 'addToCart',
      ecommerce: {
        add: {
          products: listOfTickets
        }
      }
    }

    this.logEvent(event)
  }

  public logPurchaseEvent(order: OrderType){

    const actionField: GoogleDataLayerEcommerceActionField = this.buildActionFieldProperty(order)
    const listOfTickets: Array<GoogleDataLayerEcommerceProduct> = []
    const orderTickets = order.order_tickets
    orderTickets.forEach((ticket) => {

      // If ticket is a hotel or ticket, assign the different name and variant names
      if (ticket.tags.includes('hotels')) {
        const product = this.buildProductProperty(ticket.title, ticket.product_id, ticket.price, +ticket.qty, ticket.product_title, ticket.destinations[0].title)
        listOfTickets.push(product)
      } else {
        const product = this.buildProductProperty(ticket.product_title, ticket.product_id, ticket.price, +ticket.qty, `${ticket.title} ${ticket.type}`, ticket.destinations[0].title)
        listOfTickets.push(product)
      }
    })

    const event: GoogleDataLayerEcommerceEventPurchase = {
      event: 'purchase',
      ecommerce: {
        purchase: {
          actionField: actionField,
          products: listOfTickets
        }
      }
    }

    this.logEvent(event)
  }

  /** Add an "event" object to datalayer[]. */
  public logEvent(event: GoogleDataLayerEcommerceEventPurchase | GoogleDataLayerEcommerceEventAddToCart) {
    if (window) {
      window.dataLayer = window.dataLayer || {}
      window.dataLayer.push(event)
    }
  }
}
